import './ai-sdlc.css';

export const pageTitle = 'SDLC';
export const pageSubmenu = 'AI';  

export const AISDLC = () => (
  <iframe
    src="sdlc-evolution-final_assessments.html"
    className="ai-sdlc-frame"
    title="The AI Development Lifecycle — SDLC Evolution"
  />
);